import MakeLeapsLogoFullWidth from 'assets/svg/MakeLeapsLogoFullWidth';
import ButtonLocale from 'components/Locale/ButtonLocale';
import {FC} from 'react';
import {useLocale} from 'state/locale';
import {twMerge} from 'tailwind-merge';
import {t} from 'ttag';

import {footer, footerLink} from './styles.module.css';

interface Props {
    isResponsive: boolean;
}

const PortalFooter: FC<Props> = ({isResponsive}) => {
    const locale = useLocale();

    return (
        <footer className={twMerge('flex w-full p-1', footer)}>
            <div
                className={twMerge(
                    'flex flex-1 items-start justify-center',
                    isResponsive ? 'sm:mx-8' : 'mx-8',
                )}
            >
                <div
                    className={twMerge(
                        'flex min-w-0 flex-1 flex-wrap items-center gap-x-2',
                        isResponsive ? 'max-w-[58rem]' : 'max-w-[94rem]',
                    )}
                >
                    <a
                        className={footerLink}
                        href={`https://www.makeleaps.com/${locale}/about-us/`}
                        rel="noreferrer"
                        target="_blank"
                    >
                        {t`About MakeLeaps`}
                    </a>
                    <div
                        className={twMerge(
                            isResponsive && 'flex flex-1 sm:flex-none',
                        )}
                    >
                        <a
                            className={footerLink}
                            href="https://help.makeleaps.jp/ja/articles/8687205"
                            rel="noreferrer"
                            target="_blank"
                        >
                            {t`Portal Manual`}
                        </a>
                    </div>
                    <ButtonLocale size="sm" />
                </div>
                <div
                    className={twMerge(
                        'items-center p-2 text-sm text-grey-700',
                        isResponsive ? 'hidden sm:flex' : 'flex',
                    )}
                >
                    <div className="mr-1">{t`Powered by`}</div>
                    <MakeLeapsLogoFullWidth className="mt-1 max-w-20" />
                </div>
            </div>
        </footer>
    );
};

export default PortalFooter;
